import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  ChevronRightIcon,
  CommandLineIcon,
  VariableIcon,
} from "@heroicons/react/24/outline";
import { TWclassNames } from "../../../utils/Div";
import { useUserHasAccess } from "../../../../routes/roleOnly";
import { reportVariablesPagePath } from "../../../../utils/reportVariablesUi";

/**
 * ReportDevMenu — Utvikler-/intern meny (lg+), samme tilgang som admin-menyen.
 */
export const ReportDevMenu = ({ report }) => {
  const { t } = useTranslation();
  const hasAdminAccess = useUserHasAccess({ role: "service", action: "reset" });

  if (!hasAdminAccess || !report?.id) {
    return null;
  }

  const variablesPath = reportVariablesPagePath(report.id);

  const menuItems = [
    {
      id: "variables_v2",
      label: t("report.dev.variables_v2"),
      description: t("report.dev.variables_v2_desc"),
      icon: VariableIcon,
      path: variablesPath,
      color: "text-violet-600 hover:bg-violet-50",
    },
  ];

  return (
    <div className="hidden lg:block">
      <div className="sticky top-4 rounded-xl border border-gray-200 bg-white shadow-sm">
        <div className="border-b border-gray-100 px-4 py-3">
          <div className="flex items-center gap-2">
            <CommandLineIcon className="h-5 w-5 text-gray-500" />
            <h3 className="text-sm font-semibold text-gray-800">
              {t("report.dev.title")}
            </h3>
          </div>
        </div>
        <div className="divide-y divide-gray-100 p-2">
          {menuItems.map((item) => (
            <div key={item.id}>
              <Link
                to={item.path}
                className={TWclassNames(
                  "flex items-start gap-3 rounded-lg px-3 py-2.5 transition-colors",
                  item.color
                )}
              >
                <item.icon className="mt-0.5 h-5 w-5 flex-shrink-0" />
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium">{item.label}</p>
                  {item.description && (
                    <p className="mt-0.5 truncate text-xs text-gray-500">
                      {item.description}
                    </p>
                  )}
                </div>
                <ChevronRightIcon className="h-4 w-4 flex-shrink-0 text-gray-400" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
